type Props = {
  dark?: boolean;
  light?: boolean;
};

const SvgTabIcon: React.FC<Props> = ({ dark, light }) => {
  let fillClass = "fill-primary";
  if (dark) fillClass = "fill-dark";
  else if (light) fillClass = "fill-primary-inner";

  return (
    <svg
      style={{ marginTop: -5 }}
      width="10"
      height="11"
      viewBox="0 0 10 11"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.75 0.5C3.59632 0.5 2.63992 1.37852 2.51465 2.5H2C1.42225 2.5 0.941361 2.93305 0.880861 3.5083L0.255861 9.5083C0.223111 9.8243 0.325815 10.1414 0.539065 10.3784C0.752065 10.6147 1.05675 10.75 1.375 10.75H8.625C8.94325 10.75 9.24769 10.6144 9.46094 10.3779C9.67394 10.1414 9.77689 9.8243 9.74414 9.5083L9.11914 3.5083C9.05864 2.9333 8.57775 2.5 8 2.5H7.48828C7.49603 2.5825 7.5 2.666 7.5 2.75V4.25C7.5 4.388 7.388 4.5 7.25 4.5C7.112 4.5 7 4.388 7 4.25V4.125V2.75C7 1.51182 5.98818 0.5 4.75 0.5ZM4.75 1.25C5.49744 1.25 6.10999 1.78777 6.22803 2.5H3.78321C3.76221 2.58 3.75 2.6635 3.75 2.75V4.25C3.75 4.388 3.638 4.5 3.5 4.5C3.362 4.5 3.25 4.388 3.25 4.25V4.125V2.75C3.25 1.91718 3.91718 1.25 4.75 1.25Z"
        className={fillClass}
      />
    </svg>
  );
};

export default SvgTabIcon;
